import {AppCombineReducers} from './combineReducer';
import {rootSaga} from './rootSaga';

import {configureStore} from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

const sagaMiddleWare = createSagaMiddleware();

export const appStore = configureStore({
  reducer: AppCombineReducers,
  middleware: () => [sagaMiddleWare],
  devTools: process.env.REACT_APP_ENVIRONMENT !== 'prod',
});

sagaMiddleWare.run(rootSaga);
